import Swiper, { Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

export function individualBannerSwiper() {
    Swiper.use([Autoplay, EffectFade]);

    document.querySelectorAll('.hoverEffectBanner').forEach(banner => {
        // parse your delays…
        const textDelay  = parseInt(banner.dataset.fadeText,  10) || 3000;
        const imageDelay = parseInt(banner.dataset.fadeImage, 10) || 3000;

        const [textSwiper, imageSwiper] = ['.contentText-swiper', '.contentImage-swiper']
            .map((sel, i) => {
                const container = banner.querySelector(sel);
                if (!container) return null;

                const wrapper = container.querySelector('.swiper-wrapper');
                const originalSlides = Array.from(wrapper.children);

                if (originalSlides.length <= 1) {
                    return null;
                }

                if (originalSlides.length < 3) {
                    originalSlides.forEach(s => wrapper.appendChild(s.cloneNode(true)));
                }

                return new Swiper(container, {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    loop: true,
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    speed: 1000,
                    autoplay: {
                        delay: i === 0 ? textDelay : imageDelay,
                        disableOnInteraction: false
                    },
                    allowTouchMove: false,
                    pagination: false,
                    navigation: false,
                });
            });

        const textEl  = banner.querySelector('.contentText-swiper');
        const imageEl = banner.querySelector('.contentImage-swiper');

        // only sync on non-mobile widths
        const shouldSync = () => window.innerWidth >= 768;

        function syncHeights() {
            if (!textEl || !imageEl) return;
            if (!shouldSync()) {
                textEl.style.height = 'auto';
                return;
            }
            const h = imageEl.getBoundingClientRect().height;
            textEl.style.height = `${h}px`;
        }

        // wait for images to load before first sync
        if (imageEl) {
            const imgs = imageEl.querySelectorAll('img');
            let loadedCount = 0;
            const totalImgs = imgs.length;

            if (totalImgs === 0) {
                syncHeights();
            } else {
                imgs.forEach(img => {
                    if (img.complete && img.naturalHeight !== 0) {
                        loadedCount++;
                    } else {
                        img.addEventListener('load',  () => {
                            loadedCount++;
                            if (loadedCount === totalImgs) syncHeights();
                        });
                        img.addEventListener('error', () => {
                            loadedCount++;
                            if (loadedCount === totalImgs) syncHeights();
                        });
                    }
                });
                if (loadedCount === totalImgs) {
                    syncHeights();
                }
            }
        }

        // re-run on resize
        window.addEventListener('resize', syncHeights);
    });
}
